module.exports = __webpack_public_path__ + "img/cosmos.e915ff17.svg";